/* Cart drawer v2 (Power Kitchen) - display helpers for snippets/cart-drawer-v2.liquid.
 * The drawer itself is still the theme's Vue component (theme.js RightDrawer: setQuantity, close,
 * fetchCart, wetheme.updateCartDrawer / toggleRightDrawer). This file only turns the /cart.js object
 * into a read-only view model for the template (window.wetheme.cd2.view(cart)). It never writes to the
 * cart, its attributes or line properties: custom meals are parsed from the existing `order` /
 * `custom_ids` properties for display only.
 */
(function () {
  'use strict';
  var CFG = window.CD2_CONFIG || {};
  var ING = window.CD2_INGREDIENTS || {};
  var MIN = CFG.min || 6, MAX = CFG.max || 20;
  // Customer-facing strings from locales (snippets/cart-drawer-v2.liquid -> CD2_CONFIG.i18n); English fallbacks.
  var I18N = CFG.i18n || {};
  function T(k, fb) { var s = I18N[k]; return (s && String(s).indexOf('translation missing') === -1) ? s : fb; }
  var LABELS = { protein: T('protein', 'Protein'), carb: T('carb', 'Carb'), veg: T('veg', 'Veggie') };
  var ORDER = ['protein', 'carb', 'veg'];

  var byName = {};
  Object.keys(ING).forEach(function (id) { var x = ING[id]; if (x && x.t) byName[x.t.toLowerCase()] = x; });

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function kindOf(label) {
    var l = String(label || '').toLowerCase();
    if (l.indexOf('prot') === 0) return 'protein';
    if (l.indexOf('carb') === 0) return 'carb';
    if (l.indexOf('veg') === 0) return 'veg';
    return null;
  }
  function isCustomMeal(item) {
    return /^custom meal\s*\d+/i.test(item.product_title || '') ||
      !!(item.properties && item.properties.custom_ids && item.properties.order);
  }
  function mealNumber(item) {
    var m = /(\d+)\s*$/.exec(item.product_title || '');
    return m ? parseInt(m[1], 10) : null;
  }
  // "Protein: Beef Bolognese(x2) / Veg: Mexican Corn(x1) / Carb: Broccoli Rice(x1)"
  function parseMeal(item) {
    var props = item.properties || {}, parts = {};
    String(props.order || '').split(' / ').forEach(function (seg) {
      var m = /^\s*([A-Za-z]+)\s*:\s*(.+?)\s*\(x?(\d+)\)\s*$/.exec(seg) || /^\s*([A-Za-z]+)\s*:\s*(.+?)\s*$/.exec(seg);
      if (!m) return;
      var k = kindOf(m[1]); if (!k) return;
      parts[k] = { kind: k, label: LABELS[k], name: m[2], qty: m[3] ? parseInt(m[3], 10) : 1, img: '' };
    });
    // custom_ids: "Protein_ID: 44804930207923__x2  Veg_ID: ...  Carb_ID: ..."
    String(props.custom_ids || '').replace(/([A-Za-z]+)_ID:\s*(\d+)(?:__x(\d+))?/g, function (_, lab, id, q) {
      var k = kindOf(lab); if (!k) return _;
      var ing = ING[id];
      if (!parts[k]) parts[k] = { kind: k, label: LABELS[k], name: ing ? ing.t : '', qty: q ? parseInt(q, 10) : 1, img: '' };
      if (ing && ing.i) parts[k].img = ing.i;
      return _;
    });
    ORDER.forEach(function (k) {
      var p = parts[k];
      if (p && !p.img) { var hit = byName[String(p.name).toLowerCase()]; if (hit) p.img = hit.i; }
    });
    return ORDER.map(function (k) { return parts[k] || { kind: k, label: LABELS[k], name: '', qty: 0, img: '', empty: true }; });
  }
  function planName(item) {
    var a = item.selling_plan_allocation;
    return a && a.selling_plan ? (a.selling_plan.name || T('subscription', 'Subscription')) : '';
  }
  function chips(item) {
    var out = [], props = item.properties || {};
    if (props['Delivery-Twice-Week'] != null) out.push(T('twice', 'Delivered twice a week'));
    if (item.variant_title && item.variant_title !== 'Default Title' && !isCustomMeal(item)) out.push(item.variant_title);
    return out;
  }
  function row(item, i, name, group) {
    return {
      key: item.key || (item.id + ':' + i), line: i + 1, item: item, name: name, group: group,
      thumb: sized(item.image || (item.featured_image && item.featured_image.url) || '', 160),
      plan: planName(item), chips: chips(item),
      qty: item.quantity, price: item.final_line_price, orig: item.original_line_price,
      discounted: item.original_line_price > item.final_line_price,
      discounts: (item.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; })
    };
  }

  function view(cart) {
    var v = { count: 0, custom: null, groups: [], hasSub: false, hasOneTime: false, mixed: false, savings: 0, free: null, empty: true };
    if (!cart || !cart.items) return v;
    v.count = cart.item_count; v.empty = cart.item_count === 0;
    var meals = [], gmap = {}, glist = [];
    function group(key, title, kind) {
      if (!gmap[key]) { gmap[key] = { key: key, title: title, kind: kind, rows: [], qty: 0, subtotal: 0 }; glist.push(gmap[key]); }
      return gmap[key];
    }
    cart.items.forEach(function (item, i) {
      if (planName(item)) v.hasSub = true; else v.hasOneTime = true;
      var title = item.product_title || item.title || '';
      if (isCustomMeal(item)) {
        var n = mealNumber(item), r = row(item, i, n ? T('meal', 'Meal {n}').replace('{n}', n) : title, 'custom');
        r.n = n == null ? 999 : n;
        r.parts = parseMeal(item);
        var prot = r.parts[0];
        r.placeholder = r.thumb;
        r.thumb = prot && prot.img ? prot.img : r.thumb;
        r.hasDouble = r.parts.some(function (p) { return p.qty > 1; });
        meals.push(r);
        return;
      }
      var g, name = title, segs = title.split(' - ');
      if (/^bulk\s*-\s*/i.test(title)) { g = group('bulk', T('bulk', 'Bulk Menu'), 'bulk'); name = title.replace(/^bulk\s*-\s*/i, ''); }
      else if (title.indexOf('Box') !== -1 && segs.length >= 3) { g = group('box:' + segs[0], segs[0], 'mealbox'); name = segs.slice(2).join(' - '); }
      else g = group('other', T('other', 'More items'), 'other');
      var r2 = row(item, i, name, g.key);
      g.rows.push(r2); g.qty += item.quantity; g.subtotal += item.final_line_price;
    });
    if (meals.length) {
      meals.sort(function (a, b) { return a.n - b.n; });
      var q = 0, sub = 0;
      meals.forEach(function (m) { q += m.qty; sub += m.price; });
      v.custom = {
        meals: meals, qty: q, subtotal: sub, min: MIN, max: MAX,
        missing: Math.max(0, MIN - q), over: q > MAX, ok: q >= MIN && q <= MAX,
        pct: Math.min(100, Math.round(q / MIN * 100))
      };
    }
    var order = { mealbox: 1, bulk: 2, other: 3 };
    glist.sort(function (a, b) { return order[a.kind] - order[b.kind]; });
    v.groups = glist;
    v.single = !v.custom && glist.length === 1 && glist[0].kind === 'other';
    v.mixed = v.hasSub && v.hasOneTime;
    v.savings = cart.total_discount || 0;
    var titles = [];
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) === -1) titles.push(a.title); });
    cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (d) {
      var t = d.discount_application && d.discount_application.title; if (t && titles.indexOf(t) === -1) titles.push(t); }); });
    v.discountTitles = titles.join(', ');
    var th = Math.round((CFG.freeShipping || 0) * 100);
    if (th > 0 && !v.empty) {
      var left = th - cart.total_price;
      v.free = { threshold: th, left: Math.max(0, left), reached: left <= 0, pct: Math.max(4, Math.min(100, Math.round(cart.total_price / th * 100))) };
    }
    return v;
  }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : (many || one + 's')); }

  var api = { view: view, plural: plural, sized: sized, parseMeal: parseMeal, min: MIN, max: MAX };
  window.CD2 = api;
  (function attach(tries) {
    if (window.wetheme) { window.wetheme.cd2 = api; return; }
    if (tries < 400) setTimeout(function () { attach(tries + 1); }, 25);
  })(0);

  // Font: self-hosted 'PK Montserrat' (@font-face in cart-drawer-v2.css, Shopify CDN); the browser only fetches it
  // when drawer text is rendered, so no JS loader / Google Fonts request is needed.

  // Esc closes the drawer (keyboard users).
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('js-drawer-open-right') && window.wetheme && window.wetheme.toggleRightDrawer) {
      window.wetheme.toggleRightDrawer('cart', false);
    }
  });
})();
